import React, { createContext, useState } from "react";

export const UpdateSettingContext = createContext();

export const UpdateSettingProvider = ({ children }) => {
  const [updateUser, setUpdateUser] = useState(false);
  const [updateNotification, setUpdateNotification] = useState(false);

  return (
    <UpdateSettingContext.Provider
      value={{
        updateUser,
        setUpdateUser,
        updateNotification,
        setUpdateNotification,
      }}
    >
      {children}
    </UpdateSettingContext.Provider>
  );
};
